<template>
  <CreateDialog max-width="800" v-model="model" @reject="model = false" @success="onDelete">
    <template #activator="{ on }">
      <ActionButton color="error" :loading="loading" icon="mdi-delete" v-on="on">
        Delete Contact
      </ActionButton>
    </template>
    <v-card-text class="title">
      Confirm to delete <span> {{ item.first_name }} </span>
      <span> {{ item.last_name }} </span> contact?
    </v-card-text>
  </CreateDialog>
</template>
<script>
import { contactsController } from "@/api/crm";
import CreateDialog from "../CreateDialog.vue";
import ActionButton from "./ActionButton.vue";
export default {
  components: { CreateDialog, ActionButton },
  props: {
    item: Object,
  },
  data() {
    return {
      loading: false,
      model: false,
    };
  },
  methods: {
    async onDelete() {
      this.loading = true;
      try {
        const response = await contactsController.delete(this.item.uuid);
        this.$emit("item-deleted", response.data);
        this.model = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
